import { getPopUpData } from './utils';
import { initPopUp } from '../../template/components/popUp/index';
import { getAppProps, getThemeName } from '../../utils';
import showError from '../../utils/error';
import { hookBuyItNow } from './buyItNow';
import showInfo from '../../utils/info';
import { getForm, getSubmitButton } from '../../render/common/utils';
import { PAGE } from '../../domain';

const reloadPages = {
  ['Debut']: true,
  ['Dawn']: true
};

let calls = 0;
const limit = 3;

function tryAgain() {
  calls++;
  if (calls > limit) return;
  window.setTimeout(initOtherHook, 1000);
}

function initOtherHook() {
  const { options } = getAppProps();

  const page = PAGE.Product;
  const cartForm = getForm(page, options);
  if (!cartForm) {
    tryAgain();
    return;
  }

  const submitEl = getSubmitButton(options, cartForm, page);
  if (!submitEl) {
    tryAgain();
    return;
  }

  class Wrapper {
    _addItemToCartFinal(form, contentType) {
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': contentType,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: form
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            showError(json, options, json.description);
            return;
          }

          if (reloadPages[getThemeName()]) {
            showInfo('Added to cart', options);

            // eslint-disable-next-line no-undef
            setTimeout(() => {
              // eslint-disable-next-line no-undef
              location.reload();
            }, 3000);
            return;
          }

          // eslint-disable-next-line no-undef
          location.href = '/cart';
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  }

  const wrap = new Wrapper();

  // Override event
  let shownOnce = false;

  submitEl.addEventListener('click', e => {
    if (shownOnce) return;

    const variants = getPopUpData();

    if (variants !== null) {
      shownOnce = true;
      initPopUp(wrap);
      e.preventDefault();
      return;
    }
  });
}

export default function setupShopifyAddToCartHook() {
  initOtherHook();

  hookBuyItNow();
}
